export enum OximetryMethod {
  SPO2 = 'SPO2',

  SAO2 = 'SAO2',
}
